import { useState, useRef, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Table, Alert } from 'reactstrap'
import { enterKeyHandler } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import CustomSelectListInput from '../CustomSelectListInput'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import DateRangeInput from '../DateRangeInput'
import FormHeading from '../FormHeading'
import FormSubmitButton from '../FormSubmitButton'
import TextInput from '../TextInput'

export default function ClaimFileForm({ location }) {
  console.log('ClaimFileForm rendered: ', location)

  let init = {
    defenseCounsel: '',
    dateFrom: '',
    dateTo: '',
    documentId: ''
  }

  const navigate = useNavigate()
  init = initialFormValues('ClaimFileForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))
  const [formFeedback, setFormFeedback] = useState({})

  // Scroll error messages into view
  const scrollRef = useRef(null)
  useEffect(() => {
    console.log('userEffect: ', formFeedback, scrollRef)
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView()
    }
  }, [formFeedback])

  async function submitSearch() {
    console.log('ClaimFileForm.submitSearch', inputs)

    let validInput = false
    for (let input in inputs) {
      if (inputs[input]) {
        if (inputs[input].length && inputs[input].length > 0) {
          console.log(input)
          validInput = true
        }
      }
    }
    if (!validInput) {
      return setFormFeedback({ noInput: <tr ref={scrollRef}><td colSpan={2}><Alert className='custom-alert' color='danger' style={{display: 'block', textAlign: 'center', margin: 'auto'}}>At least one input value is required</Alert></td></tr>})
    }
    setFormFeedback({})
    console.log(inputs)
    submitFormValues('ClaimFileForm', navigate, inputs, 'segal.claim_file_export')
  }

  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit} style={{ margin: '20px auto' }}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{backgroundColor: 'white'}}>
            <FormHeading headingText={'Hart Report'} />
            {formFeedback.noInput}
            <tbody>
              <CustomSelectListInput label='Defense Counsel' blankOption={true} handleChange={handleInputChange} modelName="Asbestos" entityName="outside_firm" name='defenseCounsel' defaultValue={inputs.defenseCounsel} />
              <DateRangeInput label='Date Assigned / Reopened Range' name='date' handleInputChange={handleInputChange} defaultValueFrom={inputs.dateFrom} defaultValueTo={inputs.dateTo} />
              <TextInput label='Unique ID' name='documentId' handleInputChange={handleInputChange} defaultValue={inputs.documentId} />
            </tbody>
          </Table>
        </div>
        <FormSubmitButton label='Run Report' />
      </form>
    </div>
  )
}
